import { parse } from "query-string";
import { APPLICATIONS_METADATA } from "./applications";
import {
  buildDoorkeeperSearch,
  getAndClearDoorkeeperParams,
  getAndClearRedirectParams,
} from "./oauth-redirect-storage";

export const querystring = (query) => {
  if (Object.entries(query).length === 0) {
    return ""
  }

  return `?${Object.keys(query).map((key) => `${key  }=${  query[key]}`).join("&")}`
}

export const appUrl = (redirect_app) => {
  const { url } = APPLICATIONS_METADATA[redirect_app];

  return url;
}

export const isValidSubdomainRedirect = (url) => {
  try {
    const redirectHost = new URL(url).hostname;
    const currentHost = window.location.hostname;
    const baseDomain = currentHost.slice(currentHost.indexOf(".") + 1);
    return redirectHost.endsWith(`.${baseDomain}`);
  } catch {
    return false;
  }
};

// Returns true if there are stashed Doorkeeper params and we have routed
// the browser to the Doorkeeper authorize page; in that case the caller
// should NOT continue with the dashboard redirect.
//
// This is the post-SSO routing branch for the ELMO (Doorkeeper) flow:
// SignInWithGoogle/SignInWithMicrosoft stash the Doorkeeper params before
// kicking off the social round-trip, and on return we re-inject them into
// the URL so useAuthorizeWithDoorkeeper can complete the OAuth handshake.
export const resumeDoorkeeperAuthorizeIfPending = (history) => {
  const stored = getAndClearDoorkeeperParams();

  if (!stored) {
    return false;
  }

  const search = buildDoorkeeperSearch(stored);

  if (!search) {
    return false;
  }

  history.push(`/oauth/authorize${search}`);
  return true;
};

export const redirectAfterLogin = (history) => {
  if (resumeDoorkeeperAuthorizeIfPending(history)) {
    return null;
  }

  const { search } = history.location;
  const queries = parse(search);
  const { login_redirect } = queries;

  if (login_redirect && isValidSubdomainRedirect(login_redirect)) {
    window.location = login_redirect;
    return null;
  }

  let { redirect_app, redirect_path = "" } = queries;
  let otherParams = {};

  if (!redirect_app) {
    const storedParams = getAndClearRedirectParams();
    if (storedParams) {
      redirect_app = storedParams.redirect_app;
      redirect_path = storedParams.redirect_path || "";
      otherParams = storedParams.otherParams || {};
    }
  }

  if(!APPLICATIONS_METADATA[redirect_app]) {
    return history.push("/applications");
  }

  // eslint-disable-next-line no-unused-vars
  const { code, redirect_app: _ra, redirect_path: _rp, login_redirect: _lr, ...query } = queries;
  
  const finalQuery = { ...otherParams, ...query };

  const baseUrl = appUrl(redirect_app);
  const finalUrl = `${baseUrl}${redirect_path}${querystring(finalQuery)}`;
  
  window.location = finalUrl;
  return null;
}
